<div class="modal-header">
  <h2 class="modal-title">
    {{ 'bookingModule.reviewBookings' | translate }}
  </h2>
  <button
    *ngIf="isModal"
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="onClose()"
  ></button>
</div>
<small class="p-4">{{ 'bookingModule.textReviewBooking' | translate }}</small>
<div class="modal-body">
  <div class="table-responsive">
    <table
      #dataTable="mfDataTable"
      [mfData]="tableData | recursiveFilter: filterTerm"
      [mfRowsOnPage]="showPageFooter ? limitPage : mfRowsOnPage"
      class="table table-borderless table-hover table-striped table-nowrap"
    >
      <thead class="table-light">
        <tr>
          <th
            scope="col"
            (click)="onToggleAllChecked()"
            style="width: 6%"
            class="cursor-pointer"
          >
            <input
              [checked]="allCheckedToggle"
              type="checkbox"
              class="form-check-input"
              attr.aria-label="{{ 'general.selectAll' | translate }}"
            />
          </th>
          <th scope="col" style="width: 25%">
            <mfDefaultSorter by="description">
              {{ 'productModule.product' | translate }}
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 20%">
            <mfDefaultSorter by="startDate">
              {{ 'general.day' | translate }}
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 20%">
            <mfDefaultSorter by="startDate">
              {{ 'general.startDate' | translate }}
            </mfDefaultSorter>
          </th>
          <th scope="col" style="width: 20%">
            <mfDefaultSorter by="endDate">
              {{ 'general.endDate' | translate }}
            </mfDefaultSorter>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of dataTable.data; let i = index">
          <td (click)="onCheckRow(item)" class="cursor-pointer">
            <input
              [checked]="this.checkedIds.get(item.id)"
              type="checkbox"
              class="form-check-input"
              attr.aria-label="{{ 'wcag.selectThis' | translate }}"
            />
          </td>
          <td
            (click)="onRowClicked(item)"
            (keyup.enter)="onRowClicked(item)"
            tabindex="0"
            role="link"
          >
            {{ getDescription(item.linkedProductId) | async }} -
            {{ getDescription(item.productId) | async }}
          </td>

          <td (click)="onRowClicked(item)">
            {{ 'general.day' + getDayOfWeek(item.startDate) | translate }}
            <!-- {{ ('general.day' + getDayOfWeek(item.startDate) | translate).substr(0, 2) }} -->
          </td>
          <td (click)="onRowClicked(item)">
            {{ item.startDate | date: 'YYYY-MM-dd HH:mm' }}
          </td>
          <td (click)="onRowClicked(item)">
            {{ item.endDate | date: 'YYYY-MM-dd' }}
            {{ item.endDate | date: 'HH:mm' | roundMinutes }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="mb-2 d-flex justify-content-end">
      <button class="btn btn-ghost-primary" type="button" (click)="onClose()">
        {{ 'general.back' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-soft-primary btn-hover"
        (click)="onClickSave()"
        [disabled]="tableData?.length == 0 || !tableData"
        [canSee]="[accessRights.Bookings_write]"
      >
        {{ 'general.save' | translate }}
      </button>
    </div>
  </div>
</div>
